module.exports = __webpack_public_path__ + "img/Skirt-Front-B3-Da-Gb-Ha-Ia.26deb863.png";